export default defineNuxtPlugin((nuxtApp) => {
  const defaultCurrency = useRuntimeConfig().public.defaultCurrency
  const currency = useCookie('currency')
  if (!currency.value) {
    currency.value = defaultCurrency
  }
})
